<template>
    <section :class="[namespace(), skinStyle]">
        <button :class="btnClass" type="button" @click="click($event)">
            <span :class="mdsNS('button__text')">
                {{ label }}
            </span>
            <svg
                :class="mdsNS('icon button__icon button__icon--right')"
                aria-hidden="true"
            >
                <use xlink:href="#caret-down--s"></use>
            </svg>
        </button>
    </section>
</template>
<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-menu-button',
    mixins: [mixins],
    props: {
        label: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'small'
        }
    },
    computed: {
        btnClass: function() {
            const cls = ['button', 'button--secondary'];
            if (this.size === 'small') {
                cls.push('button--small');
            }
            return this.mdsNS(cls);
        }
    },
    created() {
        this.namespace = utils.namespace('ui-menu-button', false);
    },
    methods: {
        click: function(e) {
            this.$emit('click', utils.outerSizes(e.currentTarget));
        }
    }
};
</script>
<style lang="scss">
$namespace: 'markets-ui-menu-button';
.#{$namespace} {
    button {
        white-space: nowrap;
    }
}
</style>
